export const culturesCodeEnum = {
    NETHERLANDS: 'nl-NL',
    ENGLISH: 'en-GB'
}
